<template>
    <Sheet v-loading="loading.actions['review']">
        <el-divider>
            <span style="font-size:1.1rem;padding-right: 10px;">
               申請單列表
            </span>
        </el-divider>
        <el-button
                @click="handleBatchReview"
                type="primary"
                icon="el-icon-check"
                :loading="loading.actions['review']"
        >
            批次同意
        </el-button>
        <el-button
                   icon="el-icon-refresh-right"
                   @click="refresh"
                   :loading="loading.actions['review']">
            重新載入
        </el-button>
        <el-table
                :stripe="true"
                :data="pagedForms"
                ref="reviewTable"
                empty-text="目前無待審的申請單"
                height="620px"
                @selection-change="handleSelectionChange"
        >
            <el-table-column
                    type="selection"
                    width="55">
            </el-table-column>
            <el-table-column
                    label="表單編號"
                    prop="formNo">
            </el-table-column>
            <el-table-column
                    label="申請時間"
                    prop="createdAt"
            ></el-table-column>
            <el-table-column
                    label="申請人"
            >
                <template #default="{row}">
                    {{row.applicant | prettyUsername}}
                </template>
            </el-table-column>
            <el-table-column
                    label="教室"
                    prop="roomName"
            ></el-table-column>
            <el-table-column
                    label="時段"
            >
                <template #default="{row}">
                    {{row.periods.map(p => `(${weekdays[p.weekday]})[${p.begin}-${p.end}]`).join(', ')}}
                </template>
            </el-table-column>
            <el-table-column
                    label="狀態"
                    prop="status"
            >
            </el-table-column>
            <el-table-column
                    label="操作"
            >
                <template #default="{row}">
                    <el-button
                            type="primary"
                            @click="selectAndShow(row)"
                    >
                        審核
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                style="margin-top: 10px;"
                background
                layout="total, prev, pager, next"
                :total="forms.length"
                :page-size="pageSize"
                @current-change="page => pageChange(page, forms)"
                :current-page.sync="currentPage"
        ></el-pagination>

        <el-dialog
                :visible.sync="show"
                :title="title"
                top="10px"
                @closed="onClosed"
        >
            <form-detail :form="selectedForm"></form-detail>
            <div>
                <el-divider>退件原因</el-divider>
                <div style="margin-bottom: 10px;">
                    <el-input
                            v-model="reason"
                            ref="reason"
                            type="textarea"
                            placeholder="請退件原因(不同意時需填寫)"
                    ></el-input>
                </div>
            </div>
            <template #footer>
                <el-button type="primary" :loading="loading.actions['review']" @click="onOk">同意</el-button>
                <el-button type="warning" :loading="loading.actions['review']" @click="onDeny">不同意</el-button>
                <el-button @click="show = false">關閉</el-button>
            </template>
        </el-dialog>
    </Sheet>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import formTableMixin from '../formTableMixin';
    import {Weekdays} from '../constants';

    export default {
        name: 'review',
        mixins: [formTableMixin],
        data: () => ({
            show: false,
            reason: '',
            pageSize: 30,
            selection: [],
        }),
        computed: {
            ...mapState('review', ['forms']),
            ...mapState(['loading']),

            weekdays(){
                return [...Weekdays];
            }
        },
        watch: {
            forms(current){
                this.pagedForms = this.pageData(current, 1);
            }
        },
        methods: {
            ...mapActions('review', {
                getWaitingForms: 'getWaitingFormsAction',
                sign: 'signAction',
                deny: 'denyAction',
                signAll: 'signAllAction'
            }),

            async onOk() {
                try{

                    await this.$confirm('確定要同意嗎?',{
                        type: 'warning',
                    });

                    const {success, messages} = await this.sign({
                        id: this.selectedForm.id,
                        toFst: this.toFst,
                        todo: this.todo
                    });
                    if(success){
                        this.$message.success('異動成功');
                        this.show = false;
                    } else{
                        this.$message.warning('異動失敗，請重試一次');
                        if(messages){
                            this.$message.warning(messages.join(','));
                        }
                    }
                }catch (e) {
                    if (e !== 'cancel') {
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                        this.show = false;
                    }
                }
            },
            async onDeny() {
                if(!this.reason){
                    this.$message({
                        type:'warning',
                        message: '如要退件，請說明原因!'
                    });
                    this.$refs.reason.focus();
                    return;
                }
                try {
                    await this.$confirm('確定要退回嗎?',{
                        type: 'warning',
                    });
                    const {success, messages} = await this.deny({
                        id: this.selectedForm.id,
                        reason: this.reason
                    });

                    if(success){
                        this.$message.success('異動成功');
                        this.show = false;
                    } else{
                        this.$message.warning('異動失敗，請重試一次');
                        if(messages){
                            this.$message.warning(messages.join(','));
                        }
                    }

                } catch (e) {
                    if (e !== 'cancel') {
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                        this.show = false;
                    }
                }
            },
            onClosed() {
                this.reason = '';
            },

            handleSelectionChange(val){
                this.selection = val;
            },

            async handleBatchReview(){
                if(this.selection.length <= 0){
                    this.$message({
                        message: '請選擇至少一個表單',
                        type: 'warning'
                    });
                    return;
                }
                try{
                    await this.$confirm('確定要送出嗎?',{
                        type: 'warning',
                    });
                    const {success, messages} = await this.signAll(
                        this.selection.map(s => s.id)
                    );
                    this.selection = [];
                    this.$refs.reviewTable.clearSelection();
                    if(success){
                        this.$message.success('異動成功');
                    } else{
                        this.$message.warning('異動失敗，請重試一次');
                        if(messages){
                            this.$message.warning(messages.join(','));
                        }
                    }
                }catch (e) {
                    if (e !== 'cancel') {
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                    }
                }
            },
            async refresh() {
                await this.getWaitingForms();
            }
        },

        async created() {
            await this.getWaitingForms();
        }
    }
</script>

<style scoped>

</style>